import type { ThemeConfig } from "antd";

// Savina brand color — chốt tạm dùng AntD default xanh dương + radius mềm hơn.
// Sprint 3 sẽ load token theo tenant (multi-tenant branding).
//
// Note: AntD 5.23 `.d.ts` không export `borderRadius` trong AliasToken
// nhưng runtime seed.js có (seed.js:56 borderRadius: 6). Em cast token
// portion để bypass TS check, runtime hoạt động đúng.
export const antdTheme: ThemeConfig = {
  token: {
    colorPrimary: "#1677ff",
    borderRadius: 8,
    fontFamily:
      "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  } as ThemeConfig["token"],
};
